import store from '@/app/store';
import Centrifuge from 'centrifuge';
import centrifugeSubscribe from '@/processes/Centrifuge/centrifugeSubscribe';

export default async function initCentrifuge(subscribeToVerificationProcessUid) {
	let channel = null;
	let verificationChannel = null;

	if (store.state.loan?.uid) {
		if (store.state.centrifugeStatus.loanStatus === 'money_transfer') {
			channel = `[payout.status] loan-app=${store.state.loan.uid}`;
		} else {
			channel = `[loan-app.status] loan-app=${store.state.loan.uid}`;
		}

		if (subscribeToVerificationProcessUid) {
			const env = process.env.NODE_ENV === 'development' ? 'beta' : 'prod';
			verificationChannel = `[VER.SERVICE][${env}][${subscribeToVerificationProcessUid}][verification-process.update]`;
		}
	}

	const centrifuge = new Centrifuge(store.state.WSAddress);
	centrifuge.setToken(store.state.centrifugeToken);
	centrifuge.connect();

	console.log('channel: ', channel);
	centrifuge.on('connect', async () => {
		console.log('cntrifuge on connect');
		if (channel) {
			await centrifugeSubscribe({ centrifuge, uidChannel: channel });
		}
		if (verificationChannel) {
			await centrifugeSubscribe({ centrifuge, uidChannel: verificationChannel });
		}
	});
}
